(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["axios"], factory);
	else if(typeof exports === 'object')
		exports["providers.data-entry-api-client-v1"] = factory(require("axios"));
	else
		root["providers.data-entry-api-client-v1"] = factory(root["axios"]);
})(Object(typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE_axios__) => {
return 